'use client';

import { useEffect } from 'react';

import * as Sentry from '@sentry/nextjs';

export default function GlobalError({
    error,
    reset,
}: {
    error: Error;
    reset: () => void;
}) {
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <html>
            <body>
                <h1>Что-то пошло не так.</h1>
                <button onClick={() => reset()}>Попробовать снова</button>
            </body>
        </html>
    );
}
